import type { FunctionalComponent } from 'vue'

type HomeHeaderProps = {
  title: string
  desc: string
  showDot?: boolean
}

const style = {
  title: 'text-3xl font-medium mb-4 text-h2',
  dot: 'w-2 h-2 bg-blue-2 rotate-45',
  small: 'text-1.5xl text-desc-1 mx-[7px]'
}

const HomeHeader: FunctionalComponent<HomeHeaderProps> = ({
  title,
  desc,
  showDot = true
}) => {
  return (
    <div class="text-center">
      <h2 class={style.title}>{title}</h2>
      <div class="flex-center-center">
        {showDot && <span class={style.dot}></span>}
        <small class={style.small}>{desc}</small>
        {showDot && <span class={style.dot}></span>}
      </div>
    </div>
  )
}

HomeHeader.props = {
  title: {
    type: String,
    required: true
  },
  desc: {
    type: String,
    required: true
  },
  showDot: {
    type: Boolean,
    default: true
  }
}

export default HomeHeader
